
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { formatDateWithTime, formatBool } from "@/utils";
import { DeliverBarcodeOrderRequest, DeliverItem, DeliverNoScanLineItem } from "@/models/api/barcodeSystem/barcodeOrders/deliver";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";

const barcodeSystemModule = getModule(BarcodeSystemModule);

@Component
export default class BarcodeOrderDelivering extends Vue {
  @Prop({ default: false })
  loading: boolean;

  @Prop({ default: null })
  deliverBarcodeOrderRequest: DeliverBarcodeOrderRequest;

  @Prop({default: null})
  validationMessages: string[];

  get deliverItems(): Array<DeliverItem> {
    return this.deliverBarcodeOrderRequest ? this.deliverBarcodeOrderRequest.orderItems : [];
  }

  get deliverNoScanLineItems(): Array<DeliverNoScanLineItem> {
    return this.deliverBarcodeOrderRequest ? this.deliverBarcodeOrderRequest.noScanLineItems : [];
  }

  get hasNoScanLineItems() : boolean {
    return this.deliverBarcodeOrderRequest && this.deliverBarcodeOrderRequest.noScanLineItems && this.deliverBarcodeOrderRequest.noScanLineItems.length > 0;
  }

  get isAgentObject() : boolean {
    return this.deliverBarcodeOrderRequest && this.deliverBarcodeOrderRequest.isAgentObject == true;
  }

  get statusOptions() : Array<any> {
    return this.deliverBarcodeOrderRequest && this.deliverBarcodeOrderRequest.orderItemStatuses ? 
      this.deliverBarcodeOrderRequest.orderItemStatuses.map(x => ({ label: x.description, value: x.code })) :
      [];
  }

  get deliveryExceptionOptions() : Array<any> {
    return this.deliverBarcodeOrderRequest && this.deliverBarcodeOrderRequest.orderItemStatuses ? 
      this.deliverBarcodeOrderRequest.deliveryExceptionOptions.map(x => ({ label: x == null ? "" : x, value: x })) :
      [];
  }

  get damageCodeOptions() : Array<any> {
    return barcodeSystemModule.damageCodes ?
      barcodeSystemModule.damageCodes.map(x => ({ label: x.description, value: x.code })) :
      [];
  }


  get crn(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.crn
      : ""; 
  }

  get companyName(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.companyName
      : ""; 
  }

  set companyName(val: string){
  }

  get displayBillToCompanyId(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.displayBillToCompanyId
      : "";  
  }

  set displayBillToCompanyId(val: string){
  }

  get orderNumber(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.orderNumber
      : ""; 
  }

  set orderNumber(val: string){
  }  
  
  get deliveryType(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.deliveryType
      : ""; 
  }

  set deliveryType(val: string){
  }

  get status(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.status
      : "";  
  }

  set status(val: string){
  }

  get statusDescription(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.statusDescription
      : "";  
  }

  set statusDescription(val: string){
  }

  get facilityCode(): string {
    return this.deliverBarcodeOrderRequest
      ? this.deliverBarcodeOrderRequest.facilityCode
      : ""; 
  }

  set facilityCode(val: string){
  }

  get orderItemCount() : number
  {
    return this.deliverBarcodeOrderRequest && this.deliverBarcodeOrderRequest.orderItems
      ? this.deliverBarcodeOrderRequest.orderItems.length
      : 0;
  }

  get receivedDateTimeFormatted(): string{
    return this.deliverBarcodeOrderRequest
      ? formatDateWithTime(this.deliverBarcodeOrderRequest.receivedDate)
      : "";
  }

  set receivedDateTimeFormatted(val: string){
  }

  itemIsShort(item) : boolean
  {
    return item.status == 'M';
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val) {
    return formatDateWithTime(val)
  }

  formatBool(val) {
    return formatBool(val);
  }

  onDoubleClicked(data) {
  }

  handleOrderItemDamagedChanged(data) {
    if(data.damaged)
    {
      data.quantityDamaged = data.quantity;
    }
    else
    {
      data.quantityDamaged = 0;
      data.damageCode = null;
    }
  }

  handleNoScanLineItemDamagedChanged(data) {
    if(data.damaged)
    {
      data.quantityDamaged = data.quantity;
    }
    else
    {
      data.quantityDamaged = 0;
      data.damageComment = null;
    }
  }

  handleStatusChanged(data) {
    if(this.itemIsShort(data))
    {
      data.quantityDelivered = 0;
    }
    else
    {
      data.quantityDelivered = data.quantityReceived;
    }
  }

}
